import './ArticleApp.less';
import React from 'react';
import {useParams} from 'react-router-dom';
import LoadingPlaceholder from "../../components/loading-placeholder/LoadingPlaceholder";
import {jsonToObject} from "../../../bootstrap/utils/json";
import useArticle from '../../hooks/useArticle';
import DraftView from '../../components/draft-view/DraftView';
import ImageView from '../../components/image-view/ImageView';
import Icon from '../../../bootstrap/components/icon/Icon';
import __ from '../../i18n';


export default function ArticleApp() {
    const {slug} = useParams();

    const [article, refs, isLoading] = useArticle(slug, ['image']);

    if (isLoading) {
        return <LoadingPlaceholder/>;
    }

    if (article === null) {
        return null;
    }

    // const avatarImage = refs.images.find(t => t.id === article.avatar_image_id);

    const bannerImage = refs.images.find(t => t.id === article.banner_image_id);

    const content = jsonToObject(article.content);

    return <div className="article-app">
        {
            bannerImage &&
            <div className="banner-section">
                <ImageView
                    ratio={3.5}
                    image={bannerImage}
                />
            </div>
        }
        <div className="content-section">
            <div className="header">
                <h1 className="title">{article.name}</h1>
                <div className="timestamp">
                    <Icon name="calendar"/>
                    <span>{__('Last updated ::date(DATE)', {date: article.update_time})}</span>
                </div>
            </div>
            <div className="body">
                <DraftView contentState={content}/>
            </div>
        </div>
    </div>;
}
